var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEqual = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Equal-sign"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43,37H21c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1h22c0.5527,0,1-0.4473,1-1S43.5527,37,43,37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,27H21c-0.5527,0-1,0.4473-1,1s0.4473,1,1,1h22c0.5527,0,1-0.4473,1-1S43.5527,27,43,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,0c-17.6730995,0-32,14.3268003-32,32c0,17.6730995,14.3268995,32,32,32s32-14.3269005,32-32 C64,14.3268003,49.673111,0,32,0z M32,62c-16.542099,0-30-13.457901-30-30S15.4579,2,32,2c16.5419998,0,30,13.4579,30,30 S48.5419998,62,32,62z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEqual);
export default ForwardRef;